var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"panorama-spot__build build-panorama-spot"},( _obj = {}, _obj[this.$panorama.utils.isMobile ? 'touchstart' : 'click'] = _vm.changeCorps, _obj )),[_c('div',{staticClass:"build-panorama-spot__container"},[_c('div',{staticClass:"build-panorama-spot__label"},[_vm._v(" Корпус "+_vm._s(_vm.corps)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }